module.exports = {
    title: "生动化陈列_惠合科技数字营销方案_提高效能、数据监控",
    description: "依托“快渠通”平台及惠合AI图像识别能力，惠合“业代巡拍”方案可以提高业务代表门店陈列、奖励兑付的效率，将更多的精力投入到门店管理和服务中。",
    keywords: "生动化陈列,AI图像识别,业代巡拍,门店陈列,营销奖励发放"
}